import React, { useRef, useState } from 'react';
import ProTable from '@ant-design/pro-table';
import { Modal, message, Popconfirm, Button } from 'antd';
import { queryRestrictSceneLimitList, deleteRestrictScene } from '@/services/message';

/**
 * RPA路由限制列表弹窗组件
 * @param {boolean} visible - 是否显示
 * @param {function} onCancel - 关闭回调
 * @param {boolean} showCreateButton - 是否显示新建限制按钮，默认 false
 * @param {function} onCreate - 点击新建限制时的回调，如果不传则不显示新建功能
 */
export default function RestrictListModal({ visible, onCancel, showCreateButton = false, onCreate }) {
  const actionRef = useRef();

  // 删除限制记录
  const handleDelete = async (record) => {
    const { code, msg } = await deleteRestrictScene({
      requestData: { id: record.id },
    });
    if (code === '00000') {
      message.success('删除成功');
      actionRef.current?.reload();
    } else {
      message.error(msg || '删除失败');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', align: 'center' },
    { title: '开始时间', dataIndex: 'startTime', align: 'center', valueType: 'dateTime' },
    { title: '结束时间', dataIndex: 'endTime', align: 'center', valueType: 'dateTime' },
    {
      title: '限制场景号',
      dataIndex: 'sceneList',
      align: 'center',
      render: (text) => {
        if (!text) return '-';
        if (Array.isArray(text)) {
          return text.map((item) => `[${item.name}]`).join('，');
        }
        return text;
      },
    },
    {
      title: '限制类型',
      dataIndex: 'limitType',
      align: 'center',
      render: (text) => {
        const map = { 1: '批量设置', 2: '单场景设置' };
        return map[text] || '-';
      },
    },
    { title: '创建人', dataIndex: 'createOperator', align: 'center' },
    { title: '更新人', dataIndex: 'updateOperator', align: 'center' },
    { title: '创建时间', dataIndex: 'ctime', align: 'center', valueType: 'dateTime' },
    {
      title: '操作',
      valueType: 'option',
      align: 'center',
      hideInSearch: true,
      width: 80,
      fixed: 'right',
      render: (_, record) => (
        <Popconfirm
          title="是否需要删除？"
          onConfirm={() => handleDelete(record)}
          okText="确认"
          cancelText="取消"
        >
          <a type="link">删除</a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Modal
      title="RPA路由限制列表"
      visible={visible}
      onCancel={onCancel}
      width={1000}
      footer={null}
      destroyOnClose
    >
      {showCreateButton && (
        <div style={{ marginBottom: 16, textAlign: 'right' }}>
          <Button type="primary" onClick={onCreate}>
            新建限制
          </Button>
        </div>
      )}
      <ProTable
        actionRef={actionRef}
        columns={columns}
        request={async (params) => {
          const { data, page, code } = await queryRestrictSceneLimitList({
            requestData: { ...params },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return { success: false };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        rowKey="id"
        search={false}
        pagination={{ defaultPageSize: 10 }}
        dateFormatter="string"
      />
    </Modal>
  );
}
